export const getBoundingBox = (points: number[][]) => {
  if (!points.length) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    };
  }

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  points.forEach(([x, y]) => {
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x > maxX) maxX = x;
    if (y > maxY) maxY = y;
  });

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
};

export function rotate(cx: number, cy: number, x: number, y: number, angle: number) {
  const radians = (Math.PI / 180) * angle;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const nx = cos * (x - cx) + sin * (y - cy) + cx;
  const ny = cos * (y - cy) - sin * (x - cx) + cy;

  return [nx, ny];
}

export const getCenterOfPolygon = (points: number[][]) => {
  let area = 0;
  let x = 0;
  let y = 0;

  for (let i = 0; i < points.length - 1; i++) {
    const temp = points[i][0] * points[i + 1][1] - points[i + 1][0] * points[i][1];

    area += temp;
    x += (points[i][0] + points[i + 1][0]) * temp;
    y += (points[i][1] + points[i + 1][1]) * temp;
  }

  area *= 0.5;
  x /= 6 * area;
  y /= 6 * area;

  return { x, y };
};

export const getPolygonDimension = (points: number[]) => {
  const minX = Math.min(...points.filter((_, i) => i % 2 === 0));
  const maxX = Math.max(...points.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...points.filter((_, i) => i % 2 === 1));
  const maxY = Math.max(...points.filter((_, i) => i % 2 === 1));

  return { width: maxX - minX, height: maxY - minY };
};

export const rotateBox = (
  box: { x: number; y: number; width: number; height: number },
  angle: number,
  center: { x: number; y: number },
) => {
  const corners = [
    [box.x, box.y],
    [box.x + box.width, box.y],
    [box.x + box.width, box.y + box.height],
    [box.x, box.y + box.height],
  ];

  const rotatedCorners = corners.map(([x, y]) => rotate(center.x, center.y, x, y, angle));

  return getBoundingBox(rotatedCorners);
};
